export default __webpack_public_path__ + "static/media/LexendDeca-Light.fa80f53b.ttf";